import { InjectionToken } from '@angular/core';
export let ENDPOINTS_CONFIG = new InjectionToken('endpoints.config');
export const EndpointsConfig: any = {
    famstco: {
        searchMstCo: '/famstco/searchMstCo',
        getMstCoDiv: '/famstco/getMstCoDiv'
    },
    path: {
        frontPath: 'upload/staff/',
        frontTempPath: '/tmp'
    },
    common: {
        coName: '/common/coName',
        getNationalHoliday: '/common/getNationalHoliday',
        mstResult: '/common/mstResult',
        taxinfo: '/common/taxinfo',
        searchAddress: '/common/searchAddress',
        getMstHTOrg: '/common/getMstHTOrg',
        getMstUser: '/common/getMstUser',
        getTaxRate: '/common/getTaxRate',
        getHTOrgInfo: '/common/getHTOrgInfo'
    },
    concurrent: {
        checkConcurent: '/concurrent/check',
        addConcurent: '/concurrent/add',
        deleteConcurent: '/concurrent/delete',
    },
    toppage: {
        getInfoTopPage: '/extoppage/getInfoTopPage'
    },
    examinee: {
        login: '/exauth/LoginExm',
        resetpass: '/exauth/ResetPassword',
        forgot: '/exauth/ForgotPassword',
        remove: '/exauth/removeToken',
        getToken: '/exauth/GetToken',
        ChekTiemSendMail: '/exauth/ChekTiemSendMail',
        checkUserInfo: '/exauth/checkUserInfo',
        regisUser: '/exauth/regisUser',
        sendEmailVerify: '/exauth/sendEmailVerify',
        InputInf: '/exauth/InputInf',
        GetHTorgCode: '/exauth/GetHTOrgCode',
        UpdateInfoUser: '/exauth/UpdateInfoUser'
    },
    reservation: {
        getListMstCo: '/reservation/getListMstCo',
        searchReservationStatus: '/reservation/searchReservationStatus',
        searchReservationStatusByDay: '/reservation/searchReservationStatusByDay',
        searchListMstHTCourse: '/reservation/searchListMstHTCourse',
        searchListOption: '/reservation/searchListOption',
        checkExistCourse: '/reservation/checkExistCourse',
        registerReservation: '/reservation/registerReservation',
        getReservationDetail: '/reservation/getReservationDetail',
        updateReservation: '/reservation/updateReservation',
        deleteReservation: '/reservation/deleteReservation',
        checkDateTimeRsv: '/reservation/checkDateTimeRsv',
        checkAccessRsv: '/reservation/checkAccessRsv',
        checkCourseRegistered: '/reservation/checkCourseRegistered',
        getRsvNum: '/reservation/getRsvNum',
    },
    PersonalInf: {
        getPersonalInf: '/expersonalinf/getPersonalInf',
        updPesonalInf: '/expersonalinf/updPesonalInf',
        checkEmail: '/expersonalinf/checkEmail',
        checkPass: '/expersonalinf/checkPass',
        checkUserReservation: '/expersonalinf/checkUserReservation',
    },
    inspecResult: {
        getResult: '/inspectionResult/result',
        download: '/inspectionResult/download',
        resultInfo: '/inspectionResult/resultinfo'
    },
    questionare: {
        sheets: '/questionare/sheets',
        sheetInfo: '/questionare/sheetInfo',
        registSheetInfo: '/questionare/regist',
        getInterviewSheet: '/questionare/getInterviewSheet',
    }
};
